import {LOCALE_ID, NgModule, provideZoneChangeDetection} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthInterceptor} from "./core/interceptors/auth.interceptor";

import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {SharedModule} from "./shared/shared.module";
import {ToastrModule} from "ngx-toastr";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NavbarComponent} from "./shared/components/navbar/navbar.component";

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      closeButton: true,
      timeOut: 5000,
      progressBar: true,
    }),
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    NavbarComponent,
  ],
  providers: [
    // provideClientHydration(),
    provideZoneChangeDetection({eventCoalescing: true}),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
